<template>
  <div class="m-0 dbozone-font bg-clashofwars" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">

      <div class="d-flex pt-5 justify-content-center align-items-center">
        <h5 class="game-title" :class="`-${lang} -clashofwars`">{{ $t('clashofwars.name') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <span>
          <h5 class="sub-text-gray text-des" :class="`-${lang} -clashofwars`">{{ $t('clashofwars.round-des') }}</h5>
          <span v-for="(li, index) in 5" :key="index">
            <div>
              <span class="pb-2 [t-2 sub-text" :class="`-${lang} -clashofwars`">
                {{ $t(`clashofwars.round-title${index + 1}`) }}
                <span class="sub-text-gray" :class="`-${lang} -clashofwars`">{{ $t(`clashofwars.round-des${index + 1}`)
                }}</span>
              </span>
            </div>
          </span>
        </span>

      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center pb-4">
        <h5 class="text-title" :class="`-${lang} -clashofwars`">{{ $t('clashofwars.paytable') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center pt-4">
        <h5 class="sub-text" :class="`-${lang} -clashofwars`">{{ $t('clashofwars.scatter-symbol') }}</h5>
      </div>

      <div class="symbol-container">
        <div>
          <div class="symbol-content">
            <img :src="require(`../../assets/ruleGames/clashofwars/scatter.png`)" alt="scatter-symbol"
              class="special-symbol-image" />
            <li class="sub-text-list-gray"> {{ $t('clashofwars.scatters-info') }}</li>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <h5 class="sub-text" :class="`-${lang} -clashofwars`">{{ $t('clashofwars.wild-symbol') }}</h5>
      </div>

      <div class="symbol-container">
        <div>
          <div class="symbol-content">
            <img :src="require(`../../assets/ruleGames/clashofwars/wild.png`)" alt="wild-symbol"
              class="special-symbol-image" />
            <li class="sub-text-list-gray">{{ $t(`clashofwars.wild-info1`) }}</li>
          </div>
        </div>
      </div>


      <div class="grid-container">
        <div v-for="(symbol, index) in symbols" :key="index" class="grid-item">
          <img :src="symbol.image" class="symbol-image" alt="symbol" />
          <div class="payouts">
            <div v-for="(key) in Object.keys(symbol.payouts).map(Number).sort((a, b) => b - a)" :key="key"
              class="payout-row">
              <span class="sub-text-gray-payout" :style="getDynamicMargin(symbol.id)">
                {{ key }}&nbsp;&nbsp;|
              </span>
              <span class="sub-text-payout">{{ symbol.payouts[key] }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <h5 class="sub-text-gray text-des" :class="`-${lang} -clashofwars`">{{ $t('clashofwars.paytable-des') }}</h5>
      </div>



      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title adjustment-text" :class="`-${lang} -clashofwars`">{{ $t('clashofwars.adjustment') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <div>
          <h5 class="sub-text-gray text-des" :class="`-${lang} -clashofwars`">{{ $t('clashofwars.adjustment-des') }}
          </h5>
          <div>
            <span class="m-0 sub-text ">{{ $t('clashofwars.note') }}</span>
            <span class="m-0 sub-text-gray ">{{ $t('clashofwars.note-des1') }}</span>
            <span class="m-0 sub-text-gray ">{{ $t('clashofwars.note-des2') }}</span>
          </div>
        </div>
      </div>

      <div class="d-flex pt-4 pb-2 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -clashofwars`">{{ $t('clashofwars.game-feature') }}</h5>
      </div>

      <div class="d-flex pt-2 pb-2 justify-content-center align-items-center">
        <h5 class="sub-text" :class="`-${lang} -clashofwars`">{{ $t('clashofwars.wild-on-the-way') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/clashofwars/wild_comming.png`)" alt="wild-coming"
          class="wild-comming-image" />
      </div>

      <div class="d-flex p-4 pt-5 justify-content-center align-items-center">
        <li class="sub-text-gray text-des" :class="`-${lang} -clashofwars`">{{ $t('clashofwars.wild-on-the-way-des') }}
        </li>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -clashofwars`">{{ $t('clashofwars.freespin') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/clashofwars/freespin_feature.png`)" alt="freespin-feature"
          class="freespin-feature-image" />
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <li class="sub-text-list-gray"> {{ $t('clashofwars.scatters') }}
          {{ $t('clashofwars.scatters-info') }}
        </li>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -clashofwars`">{{ $t('clashofwars.featurebuy') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/clashofwars/feature_buy_${imgLang}.png`)" alt="feature-buy"
          class="feature-buy-image" />
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <span>
          <h5 class="sub-text-list-gray pb-3">
            {{ $t(`clashofwars.featurebuy-info`) }}
          </h5>

          <ul v-for="(li, index) in 6" :key="index" class="symbol-info">
            <li v-if="index !== 3 && index !== 4" class="sub-text-list-gray">
              {{ $t(`clashofwars.featurebuy-des${index + 1}`) }}
            </li>
            <li v-else-if="index === 3" class="sub-text-list-gray">
              {{ $t(`clashofwars.featurebuy-des${index + 1}`) }}
              {{ currencyFormatterWithSymbol(betMinMax[0]) }}
              {{ $t(`clashofwars.featurebuy-des${index + 1}-1`) }}
              {{ currencyFormatterWithSymbol(featureBuyMaximum) }}
            </li>
            <li v-else-if="index === 4" class="sub-text-list-gray">
              {{ $t(`clashofwars.featurebuy-des${index + 1}`) }}
              {{ currencyFormatterWithSymbol(featureBuyMaximum) }}
              {{ $t(`clashofwars.featurebuy-des${index + 1}-1`) }}
            </li>
          </ul>

          <h5 class="sub-text-list-gray pt-2">
            {{ $t(`clashofwars.featurebuy-freespin`) }}
          </h5>

          <ul>
            <li class="sub-text-list-gray">
              {{ $t(`clashofwars.featurebuy-freespin-des1`) }}
            </li>
            <li class="sub-text-list-gray">
              {{ $t(`clashofwars.featurebuy-freespin-des2`) }}
            </li>
          </ul>

          <h5 class="sub-text-list-gray ">
            {{ $t(`clashofwars.featurebuy-superfreespin`) }}
          </h5>

          <ul>
            <li class="sub-text-list-gray">
              {{ $t(`clashofwars.featurebuy-superfreespin-des1`) }}
            </li>
            <li class="sub-text-list-gray">
              {{ $t(`clashofwars.featurebuy-superfreespin-des2`) }}
            </li>
          </ul>
        </span>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <span class="justify-content-center align-items-center">
          <h5 class="text-title" :class="`-${lang} -clashofwars`">{{ $t('clashofwars.win-line') }}</h5>
        </span>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/clashofwars/win_line.png`)" alt="win-line" class="win-line-image" />
      </div>

      <div class="d-flex p-4 pt-5 justify-content-center align-items-center">
        <li class="sub-text-gray">{{ $t('clashofwars.win-line-des') }}</li>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -clashofwars`">{{ $t('clashofwars.gamerule') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/clashofwars/slotmachine.png`)" alt="slotmachine"
          class="slotmachine-image" />
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <span>
          <li class="sub-text-gray pt-2" :class="`-${lang} -clashofwars`">
            {{ $t('clashofwars.min-bet') }}
            {{ currencyFormatterWithSymbol(betMinMax[0]) }}</li>
          <li class="sub-text-gray" :class="`-${lang} -clashofwars`">
            {{ $t('clashofwars.max-bet') }}
            {{ currencyFormatterWithSymbol(betMinMax[1]) }}
          </li>
          <li class="sub-text-gray" :class="`-${lang} -clashofwars`">
            {{ $t('clashofwars.game-rule1-1') }}
            {{ baseBet }}
            {{ $t('clashofwars.game-rule1-2') }}
          </li>
          <li class="sub-text-gray" :class="`-${lang} -clashofwars`">
            {{ $t('clashofwars.game-rule2-1') }}
            {{ currencyFormatterWithSymbol(betMinMax[0]) }}
            {{ $t('clashofwars.to') }}
            {{ currencyFormatterWithSymbol(betMinMax[1]) }}
            {{ $t('clashofwars.game-rule2-2') }}</li>
          <li class="sub-text-gray" :class="`-${lang} -clashofwars`">
            {{ $t('clashofwars.game-rule3') }}
            {{ currency + `(` + formattedCurrency + `)` }}
          </li>
          <li v-for="(li, index) in 5" :key="index" class="sub-text-gray" :class="`-${lang} -clashofwars`">
            {{ $t(`clashofwars.game-rule${index + 4}`) }}
          </li>
        </span>
      </div>



      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -clashofwars`">{{ $t('main-game.title') }}</h5>
      </div>

      <table class="control-table">
        <tr>
          <td><img :src="require(`../../assets/ruleGames/clashofwars/spin_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.spin-button') }}</h3>
            <li v-for="(li, index) in 4" :key="index" class="sub-text-gray">
              {{ $t(`main-game.spin-button-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/clashofwars/autospin_btn.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.auto_spin-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">
              {{ $t(`main-game.auto-spin-button-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/clashofwars/stop_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">
              {{ $t(`main-game.auto-spin-round-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/clashofwars/betsize_btn.png`)" alt="icon"
              class="control-icon" /></td>
          <td>
            <h3>{{ $t('main-game.bet-option-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.bet-option-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/clashofwars/turbo_on.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.turbo-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.turbo-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/clashofwars/info_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.gamerule-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.gamerule-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/clashofwars/additional_btn.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.additional-menu') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.additional-menu-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/clashofwars/setting_btn.png`)" alt="icon"
              class="control-icon" /></td>
          <td>
            <h3>{{ $t('main-game.settings') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.settings-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/clashofwars/history_btn.png`)" alt="icon"
              class="control-icon" /></td>
          <td>
            <h3>{{ $t('main-game.history-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.history-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/clashofwars/home_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.back') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.back-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/clashofwars/icon_wallet.png`)" alt="icon"
              class="control-icon" /></td>
          <td>
            <h3>{{ $t('main-game.wallet-balance-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">{{
              $t(`main-game.wallet-balance-button-des${index + 1}`) }} </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/clashofwars/icon_refresh.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.refresh-balance-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.refresh-balance-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/clashofwars/icon_bet.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.bet-amount-button') }}</h3>
            <li v-for="(li, index) in 3" :key="index" class="sub-text-gray">{{
              $t(`main-game.bet-amount-button-des${index + 1}`) }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/clashofwars/icon_win.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.winnings-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">{{ $t(`main-game.winnings-button-des${index
              + 1}`) }}</li>
          </td>
        </tr>
      </table>

      <div class="p-3"></div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'rule-clashofwars',
  props: {
    data: Object,
    lang: String,
    imgLang: String,
    betMinMax: Array,
    currentBet: Number,
    featureBuyMaximum: Number,
    currency: String,
    isShowCurrencySymbol: Boolean,
  },
  data() {
    return {
      baseBet: this.data.config.baseBet,
      betLevel: this.data.config.betLevel,
      betSize: this.data.config.betSize,
      paytable: this.data.config.payTable,
      symbols: [],
    }
  },
  mounted() {
    this.generateSymbols();
  },
  computed: {
    formattedCurrency() {
      return this.$options.filters.currencySymbol(this.currency);
    }
  },
  methods: {
    currencyFormatterWithSymbol(val) {
      if (this.isShowCurrencySymbol === false) {
        this.currency = '';
      }
      return this.$options.filters.currencyFormatterWithSymbol(val, this.currency);
    },
    decimalFormat(value) {
      value = Math.round((value + Number.EPSILON) * 1000) / 1000;
      return value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 3 });
    },
    generateSymbols() {
      const symbolsData = [];
      for (let i = 0; i < 12; i++) {
        const id = (12 - i) - 1;
        symbolsData.push({
          id: id,
          image: require(`../../assets/resultGame/clashofwars/1/symbol_${id}.png`),
          payouts: {
            5: this.decimalFormat(this.currentBet * this.data.config.payTable[id][4] / this.baseBet),
            4: this.decimalFormat(this.currentBet * this.data.config.payTable[id][3] / this.baseBet),
            3: this.decimalFormat(this.currentBet * this.data.config.payTable[id][2] / this.baseBet),
          }
        });
      }
      this.symbols = symbolsData;
    },
    getDynamicMargin(id) {
      const maxLength = this.decimalFormat(this.currentBet * this.data.config.payTable[id][4] / this.baseBet).length;
      let magin = 'calc(29%)'

      if (maxLength < 5) {
        magin = 'calc(29%)'
      } else if (maxLength === 5) {
        magin = 'calc(23%)'
      } else if (maxLength > 5 && maxLength < 7) {
        magin = 'calc(19%)'
      } else if (maxLength >= 7 && maxLength < 9) {
        magin = 'calc(16%)'
      } else if (maxLength >= 9 && maxLength < 11) {
        magin = 'calc(10%)'
      } else {
        magin = 'calc(5%)'
      }

      return {
        marginLeft: magin,
      };
    },
  }
}
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  padding: 40px;
  background-color: #202020;
  border-radius: 20px;
  margin: 20px;
}

.grid-item {
  text-align: center;
  padding-top: 10%;
}

.symbol-image {
  width: 60%;
  height: auto;
}

.payouts {
  margin-top: 10px;
}

.payout-row {
  display: flex;
  justify-content: left;
  align-items: left;
}

.symbol-container {
  margin: 5%;
  padding: 5%;
  background-color: #2d2d2d;
  color: white;
  border-radius: 10px;
}

.symbol-content {
  display: flex;
  align-items: center;
}

.special-symbol-image {
  width: 25%;
  margin-right: 20px;
}

.symbol-info {
  padding-left: 40px;
}

.symbol-info li {
  font-size: 3vw;
}

h2 {
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: bold;
}

.wild-comming-image {
  width: 70%;
  height: auto;
}

.multiplier-image {
  width: 95%;
  height: auto;
}

.freespin-feature-image {
  width: 60%;
  height: auto;
}

.feature-buy-image {
  width: 40%;
  height: auto;
}

.win-line-image {
  width: 70%;
  height: auto;
}

.win-line-container {
  padding: 20px;
  background-color: #2d2d2d;
  color: white;
  border-radius: 10px;
  max-width: 600px;
  margin: auto;
  font-family: 'Arial', sans-serif;
}

h2 {
  font-size: 24px;
  margin-bottom: 10px;
}

.win-line-images {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
}

.image-container {
  position: relative;
}

.check {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: green;
}

.cross {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: red;
}

.win-description,
.example,
.extra-info {
  margin: 10px 0;
  font-size: 14px;
}

.payout-table {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}

.payout-info ul {
  list-style: none;
  padding: 0;
}

.total-win {
  text-align: center;
}

.example-win {
  font-size: 3vw;
  color: #f39c12;
}

.extra-info {
  font-size: 12px;
  margin-top: 20px;
}

.slotmachine-image {
  width: 100%;
  height: auto;
}
</style>

<style>
.bg-clashofwars {
  background: #282828;
}

.game-title {
  font-size: 3vw;
  color: white;
}

.text-title {
  color: #fff;
  font-size: 4vw;
  text-align: center;
}

.sub-text-gray {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
}

.sub-text-gray-payout {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
  margin-left: calc(30%);
}

.sub-text-payout {
  color: #fff;
  font-size: 3vw;
  margin-left: 5%;
  text-align: left;
}

.sub-text-list-gray {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
  margin: 0 auto;
}

.sub-text {
  color: #fff;
  font-size: 3vw;
  /* margin: 0 8px; */
}

.sub-bg {
  background: #202020;
  border-radius: 30px;
}

.control-table {
  width: 100%;
  border-collapse: collapse;
}

.control-table td {
  border: 3px solid #fff;
  padding: 30px;
  vertical-align: middle;
}

.control-table h3 {
  margin-bottom: 30px;
  font-size: 3vw;
  color: #fff;
}

.control-table p {
  margin: 5px 0 0 0;
  font-size: 3vw;
}

.control-icon {
  width: 150px;
  height: 150px;
}

.adjustment-text {
  padding-left: 20%;
  padding-right: 20%;
}

.text-des {
  line-height: 1.5;
}

@media (min-width: 576px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 720px;
  }
}

@media (min-width: 768px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 900px;
  }
}

@media (min-width: 1024px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 1520px;
  }
}
</style>